module.exports = [{
      plugin: require('/home/circleci/repo/node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"custom":{"families":["Inter UI"],"urls":["/fonts/fonts.css"]}},
    },{
      plugin: require('/home/circleci/repo/node_modules/gatsby-plugin-rudderstack/gatsby-browser.js'),
      options: {"plugins":[],"prodKey":"1rAOS5TDzgx9T39bG58kwN5ZUQz","trackPage":true,"host":"https://mailgun-dataplane.rudderstack.com"},
    },{
      plugin: require('/home/circleci/repo/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-WN2J6","includeInDevelopment":false},
    },{
      plugin: require('/home/circleci/repo/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
